// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_badge_hanger_loop/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_badge_hanger_loop: ModuleSchema = {
  "id": "core_badge_hanger_loop",
  "uniqueId": "B3D_NXP1U",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-28T14:57:47.730Z",
  "label": "Badge Hanger Loop",
  "description": "Standalone core geometry module for badge hanger loop with neck (CG_LOOP02)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_LOOP02",
    "badge-hanger-loop",
    "keychain-lug"
  ],
  "sliders": [
    {
      "key": "loopHoleRadius",
      "label": "Loop Hole Radius (mm)",
      "min": 1,
      "max": 6,
      "default": 2.5,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopWallWidth",
      "label": "Loop Wall Width (mm)",
      "min": 1,
      "max": 5,
      "default": 2,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopThickness",
      "label": "Loop Thickness (mm)",
      "min": 1,
      "max": 6,
      "default": 2,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "neckWidth",
      "label": "Neck Width (mm)",
      "min": 2,
      "max": 10,
      "default": 3.75,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "neckHeight",
      "label": "Neck Height (mm)",
      "min": 0.8,
      "max": 8,
      "default": 2,
      "step": 0.2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "showKeyring",
      "label": "Show Keyring (0=Off, 1=On)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keyringDiameter",
      "label": "Keyring Diameter (mm)",
      "min": 15,
      "max": 45,
      "default": 25,
      "step": 1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keyringWireDiameter",
      "label": "Keyring Wire Diameter (mm)",
      "min": 1,
      "max": 3,
      "default": 2,
      "step": 0.2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "showBadge",
      "label": "Show Host Badge (0=Off, 1=On)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "badgeDiameter",
      "label": "Badge Diameter (mm)",
      "min": 20,
      "max": 80,
      "default": 40,
      "step": 1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        2
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "hanger",
      "label": "Hanger Loop Color",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "keyring",
      "label": "Keyring Color",
      "default": "#94a3b8",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "badge",
      "label": "Host Badge Color",
      "default": "#123b8f",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "hanger_loop",
      "name": "Badge Hanger Loop Solid",
      "parts": [
        {
          "id": "hanger_part",
          "name": "Hanger Loop with Neck",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    },
    {
      "id": "keyring_object",
      "name": "Metal Keyring Ring",
      "parts": [
        {
          "id": "keyring_part",
          "name": "Round Keyring Loop",
          "groupId": 1,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    },
    {
      "id": "badge_object",
      "name": "Host Badge Plate",
      "parts": [
        {
          "id": "badge_part",
          "name": "Round Badge Plate",
          "groupId": 2,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Keyring Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Hanger Loop Only"
    },
    {
      "id": "1",
      "label": "Download STL - Keyring Ring Only"
    },
    {
      "id": "2",
      "label": "Download STL - Badge Plate Only"
    }
  ]
};
